export enum UserPermission {
    MANAGE_LOS = 'manageLOS',
    GET_LOS = 'getLOS',
    PICKER_LOS = 'pickerLOS',

    MANAGE_SPACE_TYPE = 'manageSpaceType',
    GET_SPACE_TYPE = 'getSpaceType',
    PICKER_SPACE_TYPE = 'pickerSpaceType',

    MANAGE_DRIVER = 'manageDriver',
    GET_DRIVER = 'getDriver',
    PICKER_DRIVER = 'pickerDriver',

    MANAGE_MEMBER = 'manageMember',
    GET_MEMBER = 'getMember',
    PICKER_MEMBER = 'pickerMember',

    MANAGE_VEHICLE = 'manageVehicle',
    GET_VEHICLE = 'getVehicle',

    MANAGE_FARES = 'manageFares',
    GET_FARES = 'getFares',

    GET_THRESHOLD = 'getThreshold',
    MANAGE_THRESHOLD = 'manageThreshold',
    GET_THRESHOLD_DASHBOARD = 'getThresholdDashboard',

    GET_USERS = 'getUsers',
    MANAGE_USERS = 'manageUsers',

    MANAGE_COMPANY = 'manageCompany',
    GET_COMPANY = 'getCompany',
    PICKER_COMPANY = 'pickerCompany',

    MANAGE_ROLE = 'manageRole',
    GET_ROLE = 'getRole',

    MANAGE_NOTIFICATION = 'manageNotification',
    GET_NOTIFICATION = 'getNotification',

    MANAGE_APPOINTMENT_TYPE = 'manageAppointmentType',
    GET_APPOINTMENT_TYPE = 'getAppointmentType',
    PICKER_APPOINTMENT_TYPE = 'pickerAppointmentType',

    MANAGE_TRIP = 'manageTrip',
    GET_TRIP = 'getTrip',

    MANAGE_MEMBER_TRIP = 'manageMemberTrip',
    GET_MEMBER_TRIP = 'getMemberTrip',

    MANAGE_FUNDING_SOURCE_TRIP = 'manageFundingsourceTrip',
    GET_FUNDING_SOURCE_TRIP = 'getFundingsourceTrip',

    MANAGE_ADDON = 'manageAddon',
    GET_ADDON = 'getAddon',
    PICKER_ADDON = 'pickerAddon',

    MANAGE_STANDING_ORDER = 'manageStandingorder',
    GET_STANDING_ORDER = 'getStandingorder',

    MANAGE_FUNDING_SOURCE = 'manageFundingsource',
    GET_FUNDING_SOURCE = 'getFundingsource',
    PICKER_FUNDING_SOURCE = 'pickerFundingsource',

    MANAGE_SERVICE_AREAS = 'manageServiceareas',
    GET_SERVICE_AREAS = 'getServiceareas',
    PICKER_SERVICE_AREAS = 'pickerServiceareas',

    MANAGE_CHANGE_REASON = 'manageChangeReason',
    GET_CHANGE_REASON = 'getChangeReason',
    PICKER_CHANGE_REASON = 'pickerChangeReason',

    MANAGE_PLACE_TYPES = 'managePlaceTypes',
    GET_PLACE_TYPES = 'getPlaceTypes',
    PICKER_PLACE_TYPES = 'pickerPlaceTypes',
    MANAGE_FUNDINGSOURCE_BILLINGS = 'manageFundingSourceBillings',
    GET_FUNDINGSOURCE_BILLINGS = 'getFundingSourceBillings',

    MANAGE_PAYMENT = 'managePayment',
    GET_ACADEMY = 'getAcademy',
    MANAGE_ACADEMY = 'manageAcademy'
}
export enum UserRole {
    COMPANY = 'company',
    QUARTER = 'quarter',
    ADMIN = 'admin',
    AUTHORIZER = 'authorizer',
    DISPATCHER = 'dispatcher'
}